import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import React from 'react';
import DownloadSnapshotButton from 'components/common/DownloadSnapshotButton';
import './styles.scss';

interface IProps {
  patient: PatientWithAccessRightDTO;
}

const TableActions = (props: IProps) => {
  const { patient: currentPatient } = props;
  return (
    <div styleName="icon-actions">
      <DownloadSnapshotButton
        patientId={currentPatient.id}
        rxId={currentPatient.currentAccessRight!.id}
      />
    </div>
  );
};

export default TableActions;
